import _defineProperty from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "./index.css";
import { jsx as e, jsxs as a, Fragment as i } from "react/jsx-runtime";
import { Container as n } from "@design-system/container";
import { Section as l } from "@design-system/section";
import s from "classnames";
import r, { useState as t, useEffect as c, useCallback as o, useRef as d } from "react";
import { Link as u } from "@design-system/link";
import { Button as b } from "@design-system/button";
import g from "focus-trap-react";
import { ExtendableImage as m } from "@design-system/extendable-image";
import { isBrowser as h } from "@phx-husky/browser-helpers";
import { useScreenRecognition as v } from "@phx-husky/use-screen-recognition";

var p = function p(_ref) {
  var a = _ref.burgerCloseIcon,
      i = _ref.burgerCloseLabel,
      n = _ref.isJS;
  return n ? null : e(u, Object.assign({
    className: "cds-global-header__burger-closer",
    variant: "subtle-icon",
    href: "#close-menu",
    size: "large",
    iconSuffix: {
      props: a
    }
  }, {
    children: i
  }));
},
    f = function f(_ref2) {
  var a = _ref2.burgerCloseIcon,
      i = _ref2.burgerOpenLabel,
      n = _ref2.burgerOpenIcon,
      l = _ref2.burgerToggleLabel,
      s = _ref2.handleBurgerClick,
      r = _ref2.isOpen,
      t = _ref2.isJS,
      c = _ref2.burgerBtnRef,
      o = _ref2.isMobileView;
  return t && o ? e(b, Object.assign({
    ref: c,
    variant: "subtle-icon",
    className: "cds-navigation-mobile__burger",
    size: "large",
    iconSuffix: {
      props: r ? a : n
    },
    onClick: s,
    "aria-expanded": !!r
  }, {
    children: l
  })) : t && !o ? null : e(u, Object.assign({
    className: "cds-global-header__burger-opener",
    variant: "subtle-icon",
    href: "#open-menu",
    size: "large",
    iconSuffix: {
      props: n
    }
  }, {
    children: i
  }));
},
    O = function O(_ref3) {
  var a = _ref3.isOpen,
      i = _ref3.isJS,
      n = _ref3.isMobileView,
      l = _ref3.children;
  var s = a && i && n ? g : r.Fragment;
  return e(s, {
    children: l
  });
},
    _ = function _(_ref4) {
  var a = _ref4.className,
      i = _ref4.image,
      n = _ref4.link;
  var l = (null == n ? void 0 : n.component) || u,
      r = null == n ? void 0 : n.props;
  return e("div", Object.assign({
    className: s("cds-logo", a)
  }, {
    children: n && r ? e(l, Object.assign({}, r, {
      className: "cds-logo__link",
      variant: "wrapper",
      tabIndex: -1,
      "aria-hidden": "true"
    }, {
      children: e(m, Object.assign({}, i))
    })) : e(m, Object.assign({}, i))
  }));
},
    k = function k() {
  var _v = v(),
      e = _v.isMobile,
      a = _v.isNotMobile;

  return {
    isDesktopView: h() && a,
    isMobileView: h() && e
  };
},
    N = function N() {
  var _t = t(!1),
      _t2 = _slicedToArray(_t, 2),
      e = _t2[0],
      a = _t2[1];

  return c(function () {
    a(!0);
  }, []), [e];
},
    j = "cds-global-header__more-item",
    y = function y(_ref5) {
  var e = _ref5.listRef,
      a = _ref5.navRef,
      i = _ref5.navigationData;

  var _k = k(),
      n = _k.isDesktopView,
      _t3 = t(i),
      _t4 = _slicedToArray(_t3, 2),
      l = _t4[0],
      s = _t4[1],
      _t5 = t([]),
      _t6 = _slicedToArray(_t5, 2),
      r = _t6[0],
      d = _t6[1],
      _t7 = t(null),
      _t8 = _slicedToArray(_t7, 2),
      u = _t8[0],
      b = _t8[1],
      _t9 = t(0),
      _t10 = _slicedToArray(_t9, 2),
      g = _t10[0],
      m = _t10[1];

  c(function () {
    if ((null == e ? void 0 : e.current) && n) {
      var _a = {
        navItems: [],
        moreBtnWidth: 0
      };
      Array.from(e.current.children).forEach(function (e) {
        e.className.includes("cds-global-header__navigation-item") && _a.navItems.push({
          width: e.clientWidth
        }), e.className.includes(j) && (_a.moreBtnWidth = e.clientWidth);
      }), b(_a);
    }
  }, [e, i, n]);
  var h = o(function () {
    if (u && a.current) {
      var _e = a.current.offsetWidth,
          _n = u.navItems,
          _l = u.moreBtnWidth;

      var _r = _l + g;

      var _t11 = [],
          _c = [];
      _n.forEach(function (a, n) {
        _r += a.width, _e >= _r ? _t11.push(i[n]) : _c.push(i[n]);
      }), s(_t11), d(_c);
    }
  }, [g, a, i, u]);
  c(function () {
    h();
  }, [h, n]);

  var v = function (e) {
    var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
    var i = a;
    var n;
    return function (a) {
      n && clearTimeout(n), n = setTimeout(e, i, a);
    };
  }(h, 400);

  return c(function () {
    return n ? window.addEventListener("resize", v) : window.removeEventListener("resize", v), function () {
      window.removeEventListener("resize", v);
    };
  }, [v, u, n]), c(function () {
    var a;
    if (e.current && n) return a = new ResizeObserver(function (e) {
      var a = Array.from(e[0].target.children).find(function (e) {
        return e.className.includes("cds-global-header__navigation-logo");
      });
      (null == a ? void 0 : a.clientWidth) && m(a.clientWidth);
    }), a.observe(e.current), function () {
      a.disconnect();
    };
    e.current && !n && a && a.disconnect();
  }, [e, n]), {
    visibleItems: l,
    hiddenItems: r
  };
},
    I = function I(e, a) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "or";
  return !!e && ("or" === i ? a.some(function (e) {
    return e;
  }) : "and" === i && a.every(function (e) {
    return e;
  }));
};

function w(e, a) {
  var i = {};

  for (var n in e) {
    Object.prototype.hasOwnProperty.call(e, n) && a.indexOf(n) < 0 && (i[n] = e[n]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var l = 0;

    for (n = Object.getOwnPropertySymbols(e); l < n.length; l++) {
      a.indexOf(n[l]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[l]) && (i[n[l]] = e[n[l]]);
    }
  }

  return i;
}

var L = function L() {
  var _t12 = t(!1),
      _t13 = _slicedToArray(_t12, 2),
      e = _t13[0],
      a = _t13[1],
      i = d(),
      n = function n(e) {
    "Escape" === e.key && (i.current && clearTimeout(i.current), a(!1));
  };

  return c(function () {
    return window.addEventListener("keyup", n), function () {
      window.removeEventListener("keyup", n);
    };
  }, []), {
    handleBlur: function handleBlur() {
      i.current = setTimeout(function () {
        a(!1);
      }, 500);
    },
    handleFocus: function handleFocus() {
      i.current && clearTimeout(i.current);
    },
    handleClick: function handleClick(i) {
      i.preventDefault(), i.currentTarget.focus(), a(!e);
    },
    isOpen: e
  };
},
    B = function B(_ref6) {
  var i = _ref6.title,
      n = _ref6.ariaLabel,
      l = _ref6.navigationData,
      _ref6$linkNavElement = _ref6.linkNavElement,
      r = _ref6$linkNavElement === void 0 ? u : _ref6$linkNavElement,
      t = _ref6.activeUrlPath,
      c = _ref6.openIcon,
      o = _ref6.closeIcon;

  var _L = L(),
      d = _L.handleBlur,
      g = _L.handleFocus,
      m = _L.handleClick,
      h = _L.isOpen;

  return a("li", Object.assign({
    "aria-hidden": !l.length,
    className: s(j, _defineProperty({}, "".concat(j, "--hidden"), !l.length))
  }, {
    children: [e(b, Object.assign({
      onClick: m,
      onBlur: d,
      variant: "nav",
      size: "large",
      "aria-label": n,
      "aria-expanded": h,
      className: s({
        active: h
      })
    }, l.length ? null : {
      tabIndex: -1
    }, {
      iconSuffix: o && c ? {
        props: h ? o : c
      } : void 0
    }, {
      children: i
    })), h ? e("div", Object.assign({
      className: "cds-global-header__navigation-drop"
    }, {
      children: e("ul", Object.assign({
        className: "cds-global-header__sub-list"
      }, {
        children: l.map(function (a) {
          var i = a.label,
              n = a.href,
              l = w(a, ["label", "href"]);
          return e("li", {
            children: e(r, Object.assign({
              className: s("cds-global-header__sub-link", {
                active: t === n
              })
            }, l, {
              href: n,
              variant: "nav",
              size: "large",
              onFocus: g,
              onBlur: d
            }, {
              children: i
            }))
          }, i);
        })
      }))
    })) : null]
  }));
},
    E = function E(e, a, i) {
  return e && a ? {
    props: i ? a : e
  } : void 0;
},
    x = function x(_ref7) {
  var i = _ref7.className,
      n = _ref7.subItems,
      _ref7$linkNavElement = _ref7.linkNavElement,
      l = _ref7$linkNavElement === void 0 ? u : _ref7$linkNavElement,
      r = _ref7.subMenuLabel,
      t = _ref7.activeUrlPath,
      c = _ref7.handleFocus,
      o = _ref7.handleBlur,
      d = _ref7.isMobileView,
      b = _ref7.href;
  return e("div", Object.assign({
    className: s("cds-global-header__navigation-drop", i)
  }, {
    children: a("ul", Object.assign({
      className: "cds-global-header__sub-list"
    }, {
      children: [I(r, [!d]) && e("li", Object.assign({
        className: "cds-navigation__sub-item"
      }, {
        children: e(l, Object.assign({
          className: s("cds-navigation__sub-link", "cds-navigation__sub-link--bolder", {
            active: t === b
          }),
          "aria-current": t === b,
          href: b,
          variant: "subtle",
          size: "small",
          onFocus: c,
          onBlur: o
        }, {
          children: r
        }))
      })), n.map(function (a) {
        var i,
            n = a.label,
            r = a.href,
            u = w(a, ["label", "href"]);
        return e("li", {
          children: e(l, Object.assign({
            className: s("cds-global-header__sub-link", {
              active: t === r
            }),
            "aria-current": t === r
          }, u, {
            href: r,
            variant: "subtle",
            size: (i = !d, i ? "small" : "large"),
            onFocus: c,
            onBlur: o
          }, {
            children: n
          }))
        }, n);
      })]
    }))
  }));
},
    C = function C(_ref8) {
  var i = _ref8.className,
      n = _ref8.linkNavElement,
      l = _ref8.activeUrlPath,
      _ref8$href = _ref8.href,
      r = _ref8$href === void 0 ? "" : _ref8$href,
      t = _ref8.isMobileView,
      c = _ref8.label,
      o = _ref8.subItems,
      d = _ref8.subMenuLabel,
      g = _ref8.isJS,
      m = _ref8.openIcon,
      h = _ref8.closeIcon;

  var v = n || u,
      _L2 = L(),
      p = _L2.handleBlur,
      f = _L2.handleFocus,
      O = _L2.handleClick,
      _ = _L2.isOpen;

  return a("li", Object.assign({
    className: s("cds-global-header__navigation-item", i)
  }, {
    children: [I(c, [!g, t, !o], "or") ? e(v, Object.assign({
      className: s("cds-global-header__navigation-link", {
        active: l === r
      }),
      "aria-current": l === r,
      href: r,
      variant: "nav",
      size: "large"
    }, {
      children: c
    })) : e(b, Object.assign({
      className: s("cds-global-header__navigation-link", {
        active: (k = _, N = l, j = r, y = o, y.some(function (e) {
          return N.includes(e.href);
        }) || k || N === j)
      }),
      onClick: O,
      onBlur: p,
      variant: "nav",
      size: "large",
      "aria-expanded": _,
      iconSuffix: E(m, h, _)
    }, {
      children: c
    })), I(o, [t, _], "or") && e(x, {
      subItems: o,
      activeUrlPath: l,
      subMenuLabel: d,
      linkNavElement: n,
      handleFocus: f,
      handleBlur: p,
      isMobileView: t,
      href: r
    })]
  }));
  var k, N, j, y;
},
    S = function S(_ref9) {
  var i = _ref9.navigationName,
      n = _ref9.navigationData,
      l = _ref9.linkNavElement,
      r = _ref9.className,
      t = _ref9.closeIcon,
      c = _ref9.openIcon,
      o = _ref9.activeUrlPath,
      u = _ref9.logo,
      b = _ref9.moreBtn;

  var g = d(null),
      m = d(null),
      _k2 = k(),
      h = _k2.isMobileView,
      _N = N(),
      _N2 = _slicedToArray(_N, 1),
      v = _N2[0],
      _y = y({
    navigationData: n,
    listRef: g,
    navRef: m
  }),
      p = _y.visibleItems,
      f = _y.hiddenItems;

  return e("nav", Object.assign({
    ref: m,
    className: s("cds-global-header__navigation", r),
    "aria-label": i
  }, {
    children: a("ul", Object.assign({
      ref: g,
      className: "cds-global-header__navigation-list"
    }, {
      children: [u && e("li", Object.assign({
        className: "cds-global-header__navigation-logo"
      }, {
        children: e(_, {
          className: "cds-global-header__desktop-logo",
          image: u.imageLarge,
          link: u.link
        })
      })), p.map(function (a) {
        return e(C, Object.assign({
          linkNavElement: l,
          activeUrlPath: o,
          isMobileView: h,
          openIcon: c,
          closeIcon: t,
          isJS: v
        }, a), a.label);
      }), I(b, [v, !h], "and") ? e(B, {
        linkNavElement: l,
        activeUrlPath: o,
        navigationData: f,
        openIcon: c,
        closeIcon: t,
        title: b.title,
        ariaLabel: null == b ? void 0 : b.ariaLabel
      }) : null]
    }))
  }));
},
    D = {
  default: "inverse",
  "default-alt": "inverse-alt",
  inverse: "default",
  "inverse-alt": "default-alt"
},
    M = function M(a) {
  var i = a.children,
      n = a.mode,
      s = w(a, ["children", "mode"]);
  return e(l, Object.assign({
    element: "div",
    mode: D[n] || n,
    className: "cds-skip-link"
  }, {
    children: e(u, Object.assign({
      className: "cds-skip-link__link",
      size: "small",
      variant: "secondary"
    }, s, {
      children: i
    }))
  }));
},
    z = function z(_ref10) {
  var _ref10$linkNavElement = _ref10.linkNavElement,
      a = _ref10$linkNavElement === void 0 ? u : _ref10$linkNavElement,
      _ref10$utilityLinksDa = _ref10.utilityLinksData,
      i = _ref10$utilityLinksDa === void 0 ? [] : _ref10$utilityLinksDa,
      n = _ref10.utilityLinksName;
  return e("nav", Object.assign({
    "aria-label": n,
    className: "cds-utility-navigation"
  }, {
    children: e("ul", Object.assign({
      className: "cds-utility-navigation__list"
    }, {
      children: i.map(function (i) {
        var n = i.href,
            l = i.label,
            s = w(i, ["href", "label"]);
        return e("li", Object.assign({
          className: "cds-utility-navigation__item"
        }, {
          children: e(a, Object.assign({
            className: "cds-utility-navigation__link",
            href: n,
            variant: "subtle",
            size: "small"
          }, s, {
            children: l
          }))
        }), l);
      })
    }))
  }));
},
    V = function V(_ref11) {
  var r = _ref11.className,
      o = _ref11.logo,
      _ref11$isHeaderSticky = _ref11.isHeaderSticky,
      u = _ref11$isHeaderSticky === void 0 ? !1 : _ref11$isHeaderSticky,
      b = _ref11.skipLink,
      g = _ref11.utilityLinksData,
      m = _ref11.utilityLinksName,
      h = _ref11.mode,
      v = _ref11.linkNavElement,
      j = _ref11.burgerToggleLabel,
      y = _ref11.burgerOpenLabel,
      w = _ref11.burgerCloseLabel,
      L = _ref11.burgerOpenIcon,
      B = _ref11.burgerCloseIcon,
      E = _ref11.navigationName,
      x = _ref11.navigationData,
      C = _ref11.activeUrlPath,
      D = _ref11.moreBtn,
      V = _ref11.openIcon,
      P = _ref11.closeIcon;

  var R = d(null),
      _ref12 = function (e, a) {
    var _t14 = t(!1),
        _t15 = _slicedToArray(_t14, 2),
        i = _t15[0],
        n = _t15[1];

    return c(function () {
      var i = e.current;

      if (i && window) {
        var _e2 = new IntersectionObserver(function (_ref15) {
          var _ref16 = _slicedToArray(_ref15, 1),
              e = _ref16[0];

          n(e.intersectionRatio < 1), 1 === e.intersectionRatio && a && a(null == i ? void 0 : i.dataset.target);
        }, {
          threshold: [1, 0]
        });

        return _e2.observe(i), function () {
          _e2.unobserve(i);
        };
      }
    }, [e, a]), [i];
  }(R),
      _ref13 = _slicedToArray(_ref12, 1),
      T = _ref13[0],
      _N3 = N(),
      _N4 = _slicedToArray(_N3, 1),
      F = _N4[0],
      _ref14 = function (e) {
    var _t16 = t(!0),
        _t17 = _slicedToArray(_t16, 2),
        a = _t17[0],
        i = _t17[1],
        _t18 = t(0),
        _t19 = _slicedToArray(_t18, 2),
        n = _t19[0],
        l = _t19[1],
        s = d(null);

    return c(function () {
      i(!1);
    }, []), c(function () {
      document.documentElement.classList.toggle("cds-scroll-locked", !!a), s.current && s.current.focus();
    }, [a]), {
      isOpen: a,
      burgerBtnRef: s,
      handleBurgerClick: function handleBurgerClick(n) {
        n.preventDefault();
        var s = e.current;
        s && l(s.offsetHeight), i(!a);
      },
      burgerOffsetTop: n
    };
  }(R),
      U = _ref14.isOpen,
      W = _ref14.burgerBtnRef,
      J = _ref14.handleBurgerClick,
      A = _ref14.burgerOffsetTop,
      _k3 = k(),
      H = _k3.isDesktopView,
      $ = _k3.isMobileView;

  return a(i, {
    children: [e(M, Object.assign({}, b, {
      mode: h
    })), e(l, Object.assign({
      ref: R,
      element: "header",
      id: "open-menu",
      mode: h,
      "data-status": F ? "js" : "no-js",
      className: s("cds-global-header", r, {
        "cds-global-header--is-sticky": T && u,
        "cds-global-header--sticky-mode": u
      })
    }, {
      children: e(n, Object.assign({
        maxWidth: "max-grid"
      }, {
        children: e(O, Object.assign({
          isOpen: U,
          isMobileView: $,
          isJS: F
        }, {
          children: a("div", {
            children: [a("div", Object.assign({
              className: "cds-global-header__mobile-main"
            }, {
              children: [o && e(_, {
                className: "cds-global-header__mobile-logo",
                image: o.imageSmall,
                link: o.link
              }), e(f, {
                burgerToggleLabel: j,
                burgerOpenIcon: L,
                burgerCloseIcon: B,
                burgerOpenLabel: y,
                isJS: F,
                handleBurgerClick: J,
                isOpen: U,
                burgerBtnRef: W,
                isMobileView: $
              })]
            })), !U && $ && F ? null : a("div", Object.assign({
              style: {
                top: "".concat(A, "px")
              },
              className: "cds-global-header__burger-popup"
            }, {
              children: [I(g, [!F, H], "or") && e("div", Object.assign({
                className: "cds-global-header__top"
              }, {
                children: e(z, {
                  utilityLinksData: g,
                  linkNavElement: v,
                  utilityLinksName: m
                })
              })), e("div", Object.assign({
                className: "cds-global-header__desktop-main"
              }, {
                children: e(S, {
                  navigationName: E,
                  navigationData: x,
                  activeUrlPath: C,
                  linkNavElement: v,
                  logo: o,
                  moreBtn: D,
                  openIcon: V,
                  closeIcon: P
                })
              })), e(p, {
                burgerCloseIcon: B,
                burgerCloseLabel: w,
                isJS: F
              }), I(g, [F, $], "and") && e("div", Object.assign({
                className: "cds-global-header__bottom"
              }, {
                children: e(z, {
                  utilityLinksData: g,
                  linkNavElement: v,
                  utilityLinksName: m
                })
              }))]
            }))]
          })
        }))
      }))
    }))]
  });
};

export { V as GlobalHeader };